import Service from '@/service/index.js';
import Pagination from '@/components/pagination/index.vue';
import { changeSkin } from '@/utils/common.js';

export default {
  components: {
    Pagination
  },
  data() {
    return {
      tabActiveType: '1',
      newsList: [
        {
          'content': '<p>黑龙江农村产权交易中心有限公司（简称农交中心）是2018年9月经省政府批准，由黑龙江省农业农村厅和省国资委共同推动组建，依托黑龙江省产权交易集团有限公司设立的全省唯一的省级农村综合产权交易服务机构。    农交中心以服务“三农”为宗旨，坚持公益方向，指导建设省、市（地）、县（市、区）、乡（镇、街道）、村五级协作联动的交易服务网络体系。为各类农村产权流转交易、项目招标采购等提供交易场所、信息发布、组织交易、咨询策划及其它配套服务。    交易品种和服务范围：农村集体资产、资源交易；农户土地经营权、宅基地使用权交易；农村集体建设用地、股权、农业类知识产权交易；农村生产设施、林权交易；农村集体项目招标采购（工程建设类、物资类及服务类）；生产资料及物资供应、农产品销售服务；金融保险服务。    农交中心作为盘活农村生产要素、实现农村资产资源资本化、加快农村各类资产资源合理流动和优化配置、增加农民财产性收入、助力乡村振兴的重要平台，将紧紧围绕农业发展战略，加强市场平台建设,完善交易规则制度，不断拓展服务功能，逐步发展成集信息发布、产权交易、法律咨询、资产评估、抵押融资等于一体的为农服务综合平台，努力打造全国一流、具有龙江特色的农村产权交易市场。</p>',
          'logoUrl': require('@/assets/images/about-us/hlj.png'),
          'title': '黑龙江农村产权交易中心简介',
          'newsId': 1
        },
        {
          'content': '<p>沈阳农村综合产权交易中心有限公司（以下简称“沈阳农交中心”）是按照中央、省要求，2015年7月,经沈阳市人民政府批准，由沈阳联合产权交易所集团有限公司发起设立，受沈阳市农村产权交易监督管理委员会（简称市监委会）指导和监管。市监委会由主管副市长任主任，市直11家部门组成，市监委会办公室设在市农业农村局。市农交中心是我市农村集体产权制度改革的重要成果，是实现农村集体资产保值增值、保障农民权益的重要服务平台。2019年8月，全省农村改革现场会后，沈阳农交中心作为省内拥有独立农村产权交易竞价系统的服务平台，被省委省政府确立为辽宁省农村产权交易网络信息平台。沈阳农交中心坐落于沈河区奉天街328号产权大厦内，注册资金600万元，其中沈阳联合产权交易所集团有限公司（国有）占股比例为38.34%；沈阳华汇金融服务有限公司占股比例为33.33%；沈阳沈北兴创投资有限公司（国有）占股比例为20%；沈阳洪光资产管理有限公司（国有）占股比例为8.33%，企业性质为有限责任。我中心根据《辽宁省人民政府办公厅关于引导农村产权流转交易市场健康发展的指导意见的交易管理办法》（辽政办发【2015】114号）设立了11类交易品种包括：农村土地经营权、林权、“四荒”使用权、农村集体经营性资产、农业生产设施设备、小型水利设施使用权、农业类知识产权、农村建设项目招标及产业项目招商和转让、水域滩涂养殖使用权、农村集体经营性建设用地使用权、其他依法可以流转交易的农村产权业务。2019年12月，省农业农村厅起草的《辽宁省农村产权交易市场管理办法（征求意见稿）》，明确省内集体经营性资产、资源性资产的转让、出租、入股、抵押等必须通过辽宁沈阳农村综合产权交易平台交易。我们依据省厅的管理办法，修订了“1+7”交易规则并发放给各市、县、乡。我中心按照省、市、县、乡四级架构铺设市场经营体系，其中：中心为省级中心市场，各市为市级分市场，各市涉农区县设立分支机构，在各区县的乡镇政务服务大厅设立乡镇服务站。目前，沈阳市全市9个涉农区县（市）已完成沈北新区、于洪区、辽中区、浑南区、铁西区、苏家屯区、新民市7个分中心，康平县、法库县2个办事处的挂牌运营工作。省级平台建设也完成了由14个市、16个县、63个乡镇参加的全省农村产权网络信息平台操作技能四期培训班，标志着全省农村产权四级运营体系全部准备就绪。截至目前，沈阳农交中心总计交易项目294宗，涉及面积19.6万亩，交易金额6.8亿，其中土地流转项目经过沈阳农交中心竞价系统公开竞价，平均竞价增值率7.85%，单一项目最高增值率57.8%；林木流转项目平均竞价增值率高达36.73%，单一项目最高增值率109.97%。几年来，省、市主要领导和主管领导先后到沈阳农交中心视察并指导工作，对市场建设情况给予充分肯定。</p>',
          'logoUrl': require('@/assets/images/about-us/lnsy.png'),
          'title': '沈阳市农村综合产权交易中心简介',
          'newsId': 2
        },
        {
          'content': '<p>天津农村产权交易所有限公司（以下简称天津农交所）是经天津市人民政府批准设立和唯一指定的集体资产资源流转交易服务平台，由天津市农委牵头，联合天津产权交易中心、宝坻区人民政府三方共同出资组建的国有全资企业，注册资金为2000万元。2014年，为进一步加强天津市农村集体“三资”监督管理，天津市委办公厅、天津市人民政府办公厅联合下发《关于进一步加  强农村集体资金资产资源监督管理工作的意见》（津党厅〔2014〕29号），明确提出“农村集体资产资源的流转交易和工程项目招投标都要在天津农村产权交易所公开进行”。2015年，为构建全市统一规范的农村产权流转交易市场，天津市人民政府办公厅下发《关于加快健全完善我市农村产权流转交易市场的意见》（津政办〔2015〕99号），明确提出“天津农村产权交易所是市级农村产权流转交易服务平台，为市场化服务组织，主要负责全市范围内农村产权流转交易信息的登记与发布、农村产权流转交易活动的组织及配套服务工作，制定全市统一规范的市场管理制度和交易规则”。作为配套天津市农村产权制度改革的重要载体，2016年，天津农交所在全国省级层面率先完成了“镇街—区—市”三位一体市场服务体系并建立了全国领先的农村产权流转交易信息系统，按照“六统一”交易模式，即“统一监督管理、统一交易系统、统一信息发布、统一交易规则、统一交易流程、统一收费标准的整体运营标准”来进行市场管理。截止目前，天津农交所在全市10个涉农区均已设立分市场，在153个涉农镇街建立工作站，成为国内第一个建立标准化、系统化、规范化市场网络和交易系统的农村产权交易所。天津农交所主要开展8类农村资产流转交易，具体为：【农户承包土地经营权】指以家庭承包方式承包的耕地、养殖水面、草地等土地经营权。【农村集体资源性资产】主要包括归村集体全体成员集体所有的耕地、设施农用地、四荒地、农田水利用地、鱼池、坑塘水面、养殖水面、果园、山场等。【农村经营性资产】主要包括归村集体所有、农民专业合作社、其他经济组织或个人所有的房屋、建筑物、股权、种蓄禽、交通运输工具、商铺等。【农村建设项目招标和采购】农村建设项目招标和采购统一进入天津农交所线上平台进行信息发布，农交所会同区、镇（街）农经管理部门本着公平、公开、公正的原则，出席开标现场，并为此次开标出具交易鉴证。【林权】指归村集体所有、农民专业合作社、其他经济组织或个人所有的林木所有权的流转。【农业生产设施设备】主要包括归村集体所有、农民专业合作社、其他经济组织或个人所有的拖拉机、挖坑机、雪铲、灭茬机、联合收割机、储存农用机具等。【小型水利设施】主要包括农户、农民合作组织、农村集体和涉农企业等拥有的井泵、水闸、泵站、水库、田间灌排工程等。 【涉农知识产权】指权利人拥有的著作权、专利权、商标权的流转。随着天津现代都市型农业的快速发展及农村产权制度改革的不断深入，天津农交所为各类集体产权交易提供了更加规范、公平、公开的交易平台，帮助涉农资产资源保值增值，引导社会资本向农村流动，优化农村资源配置，增加农民财产性收入，服务我市农业农村发展改革。天津农交所将本着规范、创新、联合、发展的理念；以公开、公平、公正为原则；以服务“三农”为宗旨，与社会各界精诚合作，共创美好未来！</p>',
          'logoUrl': require('@/assets/images/about-us/tjcq.png'),
          'title': '天津市农村产权交易所简介',
          'newsId': 3
        }
      ],
      pageNum: 1,
      pageSize: 5,
      total: 0
    };
  },
  created() {
    // this.getNewsList();
  },
  watch: {
    // $route () {
    //   this.getNewsList();
    // }
  },
  computed: {
  },
  methods: {
    changeSkin,
    // formate日期
    getCreatedTimeDay (date) {
      const baseDateFilter = this.$options.filters['baseDate'];
      const baseDate = baseDateFilter(date);
      return baseDate.substring(8, 10);
    },
    getCreatedTimeYear (date) {
      const baseDateFilter = this.$options.filters['baseDate'];
      const baseDate = baseDateFilter(date);
      return baseDate.substring(0, 7);
    },
    // 详情
    toDetailPage(id) {
      this.$router.push({
        path: '/about-us/market-member-detail',
        query: {
          id: id
        }
      });
    },
    changeTabIndex(type) {
      this.tabActiveType = type;
      this.getNewsList();
    },
    getNewsList(page) {
      if (page) {
        this.pageNum = page.pageNo;
        this.pageSize = page.pageSize;
      }
      const type = this.$route.params.type;
      const params = {type: 1, partId: type, pageNum: this.pageNum, pageSize: this.pageSize};
      Service.getNewsList(params).then(res => {
        if (res && res.code === '0') {
          this.total = res.data.total;
          this.newsList = res.data.list;
          this.news1 = this.newsList[0];
        }
      });
    }
  }
};
